<template lang="pug">
#SchoolInfo.school-info.pv2
    .container(:class="{ selected }")
        h2.h7.mb3 {{ school.School_Name }}
        table.mb3
            tr(v-if="school.Campus_Name !== school.School_Name")
                th Campus
                td {{ school.Campus_Name }}
            tr
                th Specialisation
                td {{ school.Specialisation }}
                        br
                        a(href="#" v-show="!showDesc" v-on:click.prevent="showDesc=true") More info
            tr(v-if="school.Specialisation_Desc && showDesc")
                td.specialisation_desc(colspan="2"  @click="showDesc=false") 
                    div {{ school.Specialisation_Desc }}
            tr
                th Years
                td {{ school.Campus_Year_Levels }}
            tr
                th Address
                td {{ school.Campus_Address_Line_1 }}
                    br
                    | {{ school.Campus_Address_Town }} {{ school.Campus_Postcode }}
            tr
                th Contact
                td
                    .phone Ph: {{ school.School_Phone }}
                    a.website(:href="school.School_Website" target="_blank")  Website
        div(v-if="dtaTypes.length > 1")
            p Your address is in multiple DTAs for this school.
            div(v-for="type in dtaTypes")
                p.f7.b.mb0.pa0 {{ type }}
                a.link.tc.db.ph3.pv2.ma2.center.show-btn.dim(@click="showOnMap($event, type)" href="#map") Show on map
        div(v-else)
            div(v-if="school.DTA_Type !== school.Specialisation")
                p This school has multiple DTAs. Your address is in the <b>{{ school.DTA_Type }}</b> DTA.
            div 
                a.tc.db.ph3.pv2.mt2.center.show-btn(@click="showOnMap($event, school.DTA_Type)" href="#map") Show on map
</template>

<script>
import { EventBus } from '../EventBus';
export default {
    name: "SchoolInfo",
    props: ['school', 'selected'],
    data: () => ({
        showDesc: false
        
    }),
    created() {
        window.SchoolInfo = this;
        EventBus.$on('boundary-results', () => this.showDesc = false);
    },
    computed: {
        dtaTypes() {
            return this.school.DTA_Types.sort((a, b) => a < b ? -1 : 1);
        }
    },
    methods: {
        showOnMap(e, type) {
            EventBus.$emit('select-dta', this.school, type);
            if (window.innerWidth >= 768) {
                // on mobile, we want to allow a #map URL so forwards/back works.
                e.preventDefault();
            }
        }
    }
};

</script>

<style scoped>
h2 {
    text-align: center;
    margin-top: 0;
    font-size: 16px;
    padding-bottom: 0.5em;
    border-bottom: 1px solid #8080806e;
}

.container {
    background: #e8effc;
    padding: 1em;
    border-radius: 3px;
    box-shadow: 0 0 0 2px rgba(0,0,0,0.1), 0 0 1px 0 rgba(128, 128, 128, 1);
    border: 4px solid rgba(128, 128, 128, 0);
    transition: border 0.2s ease;
}

.selected {
    border: 4px solid hsl(220,80%,30%);
}

.show-btn {
    background-color: hsl(220,80%,50%);
    color: hsl(220,80%,95%);
    font-weight:500;
    border-radius:4px;
    transition: background-color 0.2s linear;
    text-decoration: none;
}

.show-btn:hover {
    background-color: rgb(21, 75, 182);
}

.school-info th {
    text-align: left;
    width: 38%;
}

.school-info td {
    padding-left: 0.5em;
    color: #555;
    /* Needs the right font for 100 to look good */
    font-weight:400;
}

@media print {
    .school-info {
        border-top: none;
    }
}

.address {
    color: #555;
    text-align:left;
    /* font-size: 80%; */
}

.specialisation_desc div {
    line-height:1;
    background:hsl(220,80%,98%); 
    border-radius:6px;
    padding:0.25em 0.5em;
    box-shadow: 2px 2px 3px 3px hsla(0,0%,70%,0.5);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.maplink {
    text-align: center;
    cursor: pointer;
    color: hsl(240, 100%, 46.7%);
    text-decoration: underline;
    padding: 1em;
    font-size: 14px;
}

table {
    width: 100%;
    font-size: 14px;
    line-height:1;
}

th {
    vertical-align:top;
}
td,th {
    padding-top:1em;
    line-height: 1.4;
}

tr:first-child td,
tr:first-child th,
.specialisation_desc{
    padding-top:0;
}

.specialisation_desc div {
    line-height:1;
    background:hsl(220,80%,98%); 
    border-radius:6px;
    padding:0.25em 0.5em;
    box-shadow: 2px 2px 3px 3px hsla(0,0%,70%,0.5);
}

</style>